import { Questionnaire } from '../../components/Questionnaires/types';
import { coreApi } from '../../utils/axios';
import { GetIsQuestionnaireAttachedResponse, GetQuestionnairesResponse } from './types';

export const getQuestionnaire = async (id: string): Promise<Questionnaire> => {
  const response = await coreApi.get<GetQuestionnairesResponse>(`/questionnaires/${id}`);

  return response.data.data[0];
};

export const postQuestionnaire = async (questionnaire: FormData): Promise<Questionnaire> => {
  const response = await coreApi.post<GetQuestionnairesResponse>('/questionnaires', questionnaire);

  return response.data.data[0];
};

export const putQuestionnaire = async (id: string, questionnaire: FormData): Promise<Questionnaire> => {
  const response = await coreApi.put(`/questionnaires/${id}`, questionnaire);

  return response.data.data[0];
};

export const deleteQuestionnaire = async (id: string): Promise<void> => {
  return await coreApi.delete(`/questionnaires/${id}`);
};

export const getQuestionnaires = async (page: number, limit: number) => {
  const response = await coreApi.get<GetQuestionnairesResponse>(`/questionnaires?page=${page}&limit=${limit}`);

  return response.data;
};

export const searchQuestionnaires = async (searchTerm: string) => {
  const response = await coreApi.post<GetQuestionnairesResponse>(`/questionnaires/search?search=${searchTerm}`);

  return response.data;
};

export const getIsQuestionnaireAttached = async (id: string) => {
  const response = await coreApi.get<GetIsQuestionnaireAttachedResponse>(`/questionnaires/${id}/is-attached`);

  return response.data.data[0].is_attached;
};
